// icon figma

export const Guidance = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='2em' height='2em' viewBox='0 0 32 33' fill='none' {...props}>
    <g opacity='0.6'>
      <g clipPath='url(#clip0_1326_6869)'>
        <circle
          cx='15.9998'
          cy='16.7501'
          r='9.73958'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <circle
          cx='16'
          cy='16.75'
          r='2.0625'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <ellipse
          cx='15.9998'
          cy='19.3067'
          rx='7.18294'
          ry='7.18294'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <ellipse
          cx='15.9998'
          cy='14.1934'
          rx='7.18294'
          ry='7.18294'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </g>
    <defs>
      <clipPath id='clip0_1326_6869'>
        <rect
          width='22'
          height='22'
          fill='white'
          transform='translate(5 5.75)'
        />
      </clipPath>
    </defs>
  </svg>
)
